"use client"
import { writeFirstTouchIfEmpty } from "@/src/utils/tracking/firstTouch"
import { useEffect } from "react"

export const useLandingUrl = () => {
    useEffect(() => {
        writeFirstTouchIfEmpty(window.location.href)
    }, [])
}
